'use client'

import { create } from 'zustand'

export type Theme = 'light' | 'dark'

interface ThemeState {
  theme: Theme
  setTheme: (theme: Theme) => void
  toggleTheme: () => void
}

const THEME_COOKIE = 'nivex-theme'

function persistTheme(theme: Theme) {
  if (typeof document === 'undefined') return
  document.cookie = `${THEME_COOKIE}=${theme}; path=/; max-age=31536000`
  window.localStorage.setItem(THEME_COOKIE, theme)
}

/**
 * Module-scope store — safe because theme is UI-only, not user data. It must
 * NOT be initialized from window/localStorage here (that would crash SSR);
 * the server-read cookie value is hydrated in via ThemeProvider instead.
 */
export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: 'light',
  setTheme: (theme) => {
    set({ theme })
    persistTheme(theme)
  },
  toggleTheme: () => {
    const next = get().theme === 'dark' ? 'light' : 'dark'
    set({ theme: next })
    persistTheme(next)
  },
}))
